export default "__VITE_ASSET__fNA4XD3f__"